import React, { useEffect, useState } from "react";
import "./styles.css";
import searchAbort from "../../images/searchClose.svg";

const Popup = ({ show, onClose, onSubmit, stops, src, dest }) => {

  const convertTo24HrFormat = (timeStr) => {
    if (typeof timeStr !== 'string') {
      timeStr = String(timeStr);
    }
      timeStr = timeStr.padStart(4, '0');
      let timeWithColon = timeStr.slice(0, 2) + ':' + timeStr.slice(2);
  
    return timeWithColon;
  };
  const preprocessItems = (items) => {
    return items.map(item => {
      let day = Number(item.day);
      let timeStr = String(item.time).padStart(4, '0');
      return { ...item, day: day, time: timeStr };
    });
  };
  
  const preprocessedItems = preprocessItems(stops);
  
  const updatedStops = preprocessedItems.sort((a, b) => {
    if (a.day !== b.day) {
      return a.day - b.day;
    } else {
      return a.time.localeCompare(b.time);
    }
  });
  
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-head">
          Are you sure to add below stops from {src.city_name} to{" "}
          {dest.city_name} ?{" "}
          <img onClick={onClose} src={searchAbort} className="close-popup" />
        </div>
        <div className="popup-stops">
          <table className="popup-table">
            <thead>
              <tr className="popup-table-header">
                <th>S.No</th>
                <th>Stop Name</th>
                <th>Stop Address</th>
                <th>Day</th>
                <th>Time</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              {updatedStops.map((el, i) => (
                <tr key={el.address} className="popup-table-row">
                  <td>{i + 1}</td>
                  <td>{el.name || el.place_name}</td>
                  <td>{el.address || el.place_address}</td>
                  <td>{el.day}</td>
                  <td>{convertTo24HrFormat(el.time)}</td>
                  <td>{`${el.duration} mins` || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="popup-buttons">
          <div className="popup-cancel-button" onClick={onClose}>
            Cancel
          </div>
          <div className="popup-submit-button" onClick={onSubmit}>
            Submit
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
